import React, { Fragment, KeyboardEvent } from 'react'
import { css } from '@emotion/core'
import { Form, Formik, FormikActions } from 'formik'
import * as Yup from 'yup'
import { Button, Input } from '@dw/helix'

interface Props {
  serials: string[][]
  addSerial: (serial: string) => void
  removeSerialGroup: (groupToRemove: string[]) => void
  removeSerial: (serialToRemove: string) => void
  removeAllSerials: () => void
  serialValidationSchema: Yup.Schema<string>
  deleteMode: boolean
  deleteModeToggle: () => void
}

interface State {
  showManualInput: boolean
}

const addSerialRowStyles = css`
  display: flex;
  align-items: flex-start;
`
const inputWrapperStyles = css`
  margin-right: 10px;
  width: 100%;
`

export class AddSerialForm extends React.Component<Props, State> {
  state: State = {
    showManualInput: false,
  }

  private manualSerialInputFormValidationSchema = Yup.object().shape({
    'manual-serial': this.props.serialValidationSchema,
  })

  render() {
    const { deleteModeToggle, deleteMode, removeSerialGroup, removeSerial, serials, removeAllSerials } = this.props
    const serialsCount = serials.reduce((acc, val) => acc.concat(val), []).length

    return (
      <div className="panel reference-box">
        <div className="panel-heading">
          Serial no's | Scanned: <span className="scanned-count">{serialsCount}</span>
          <button id="manual-input-btn" className="manual-input-btn" onClick={this.showManualInputToggle}>
            Manual Input
          </button>
        </div>
        <div className="panel-body">
          {!!serials.length && (
            <button className="btn btn-default dw-btn dw-redbtn" id="scan-delete-btn" onClick={deleteModeToggle}>
              {deleteMode ? 'Delete mode active..' : 'Activate Delete Mode'}
            </button>
          )}
          <ul className="scanned-items-cont">
            {serials.map((serialsGroup, groupIndex) => (
              <Fragment key={groupIndex}>
                <li>
                  <span
                    className="glyphicon glyphicon-remove glyphicon-remove-large"
                    onClick={() => removeSerialGroup(serialsGroup)}
                  />
                </li>
                <li>
                  <ul className="scanned-items-list">
                    {serialsGroup.map(serial => (
                      <li key={serial}>
                        {serial}
                        <span
                          className="glyphicon glyphicon-remove glyphicon-remove-small"
                          onClick={() => removeSerial(serial)}
                        />
                      </li>
                    ))}
                  </ul>
                </li>
              </Fragment>
            ))}
          </ul>

          {this.state.showManualInput && (
            <div data-component="addserialmanual-component">
              <Formik
                initialValues={{ 'manual-serial': '' }}
                validationSchema={this.manualSerialInputFormValidationSchema}
                onSubmit={this.handleSubmit}
                render={({ isValid, setFieldValue, values, errors, submitForm }) => (
                  <Form>
                    <div css={addSerialRowStyles}>
                      <div css={inputWrapperStyles}>
                        <Input
                          name="manual-serial"
                          value={values['manual-serial']}
                          onChange={event => {
                            setFieldValue('manual-serial', event.target.value)
                          }}
                          placeholder="Serial number"
                          onKeyDown={(event: KeyboardEvent<HTMLInputElement>) => {
                            if (event.key === 'Enter') submitForm()
                          }}
                          status={errors['manual-serial'] ? `error` : undefined}
                          hint={errors['manual-serial']}
                          hasHint={true}
                        />
                      </div>
                      <Button
                        id="add-serial-btn"
                        theme="primary"
                        type="submit"
                        disabled={!isValid}
                        css={css`
                          line-height: 16px;
                        `}
                      >
                        Add
                      </Button>
                    </div>
                  </Form>
                )}
              />
            </div>
          )}
          {serials.length > 0 && (
            <button className="btn btn-default dw-btn dw-redbtn clear-scans" onClick={removeAllSerials}>
              Clear all
            </button>
          )}
        </div>
      </div>
    )
  }

  private handleSubmit = (values: any, actions: FormikActions<any>) => {
    this.props.addSerial(values['manual-serial'])
    actions.resetForm()
  }

  private showManualInputToggle = () => this.setState({ showManualInput: !this.state.showManualInput })
}
